import React, {useState, setGlobal, getGlobal, useEffect} from 'reactn';
import { Radio, Checkbox, Button, Skeleton, notification, Popover} from 'antd';
import { useFirestore } from 'reactfire';
import {useParams} from 'react-router-dom';

const Tinnitis = (props) => {
    const [isTinnitis, setTinnitis] = useState('No');
    const [popup, setPopup] = useState(false);
    let { appointmentId } = useParams();
    const firestore = useFirestore();
    const [state, setState] = useState({});
    const [loading, setLoading] = useState(false);
    const [loadingBtn, setLoadingBtn] = useState(false);
    const getSelectedFields = (event) => {
        setState({
            ...state,
            [event.target.name] : event.target.value
        });
    }
    useEffect(() => {
        getCurrentCCLocation();
    }, []);

    const getCurrentCCLocation = () => {
        let records = [];
        setLoading(true);
        firestore.collection("ChiefComplaints").where("appointment_id", "==", appointmentId).get()
        .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                records.push({data: doc.data(), id: doc.id});
            });
        }).finally(() => {
            if (records.length> 0 && records[0].data && records[0].data.ChiefComplaints_location && records[0].data.ChiefComplaints_location.LeftEar && records[0].data.ChiefComplaints_location.LeftEar.Tinnitis) {
                let thisObj = records[0].data.ChiefComplaints_location.LeftEar.Tinnitis;
                setState(thisObj ? thisObj : {});
                setTinnitis(thisObj ? 'Yes' : 'No');
                if (!thisObj) {
                    assignDefaultValues();
                }
            } else {
                assignDefaultValues();
            }
            setLoading(false);
        })
    }

    const assignDefaultValues = () => {
        // if (!state) {
            assignDefaultValuesAnyways();
        // }
    }

    const assignDefaultValuesAnyways = () => {
        setState({
            'Duration' : '< week',
            'Onset' : 'Sudden',
            'Progression' : 'Not Progressive',
            'Fluctuating' : 'No',
            'Severity' : 'Mild',
            'Noise Intolerance' : 'No',
            'Aggravating Factors' : 'Not Known',
            'Relieving Factors' : 'Not Known',
            'Causative Factors' : 'Not Known',
            'Assocaited Symptoms' : 'Not Known',
            'Treatment Taken' : 'Not Known',
            'Using Hearing Aids' : 'No',
            'Family History of hearing Loss' : 'No'

        });
    }

    const getCheckBoxONChange = (value, target) => {
        setState({
            ...state,
            [target] : value
        });
    }

    const saveTheForm = () => {
        // let previosuValues = {};
        // if (getGlobal().ChiefComplaints_location) {
        //     previosuValues = {...getGlobal().ChiefComplaints_location.LeftEar};
        // } else {
        //     previosuValues = {}
        // }
        // let objectToSave = {
        //     'LeftEar': {
        //         ...previosuValues,
        //         'Tinnitis' : {'isTinnitis': isTinnitis, ...state}
        //     }
        // }
        setLoadingBtn(true);
        let previosuValues = {};
        if (getGlobal().ChiefComplaints_location) {
            previosuValues = {...getGlobal().ChiefComplaints_location};
        } else {
            previosuValues = {}
        }
        let objectToSave = {
            ...previosuValues,
            'LeftEar': {
                ...previosuValues.LeftEar,
                'Tinnitis' : {'isTinnitis': isTinnitis, ...state}
            }
        }

        // console.log(objectToSave);

        if (getGlobal().ChiefComplaints_location_id) {
            firestore.collection('ChiefComplaints').doc(getGlobal().ChiefComplaints_location_id).update({
                ChiefComplaints_location: objectToSave,
            }).then(() => {
                notification.open({
                    message: 'Record Successfully Updated',
                    // icon: <DeleteOutlined style={{ color: '#f00' }} />,
                });
            }).catch(() => {
                notification.open({
                    message: 'An Error Occured',
                    // icon: <DeleteOutlined style={{ color: '#f00' }} />,
                });
            }).finally(() => {
                props.hasSaved();
                setLoadingBtn(false);
            });
        } else {
            firestore.collection('ChiefComplaints').add({
                patient: firestore.collection("patients").doc(getGlobal().patientID),
                appointment: firestore.collection("appointments").doc(getGlobal().appointmentId),
                appointment_id: getGlobal().appointmentId,
                date: new Date(),
                ChiefComplaints_location: objectToSave,
            }).then(() => {
                notification.open({
                    message: 'Record Successfully Added',
                    // icon: <DeleteOutlined style={{ color: '#f00' }} />,
                });
            }).catch(() => {
                notification.open({
                    message: 'An Error Occured',
                    // icon: <DeleteOutlined style={{ color: '#f00' }} />,
                });
            }).finally(() => {
                props.hasSaved();
                setLoadingBtn(false);
            });
        }
    }

    const deleteTinnitis = () => {

        let previosuValues = {};
        if (getGlobal().ChiefComplaints_location) {
            previosuValues = {...getGlobal().ChiefComplaints_location};
        } else {
            previosuValues = {}
        }
        let objectToDelete = {
            ...previosuValues,
            'LeftEar': {
                ...previosuValues.LeftEar,
                'Tinnitis' : null
            }
        }



        firestore.collection('ChiefComplaints').doc(getGlobal().ChiefComplaints_location_id).update({
            ChiefComplaints_location: objectToDelete
            
        }).then(() => {
            notification.open({
                message: 'Record Successfully Delete',
                // icon: <DeleteOutlined style={{ color: '#f00' }} />,
            });
            setGlobal({ChiefComplaints_location: {...getGlobal().ChiefComplaints_location.LeftEar, Tinnitis: null}})
            setPopup(!popup)
            props.hasSaved();
            // assignDefaultValuesAnyways();
        }).catch(() => {
            notification.open({
                message: 'An Error Occured',
                // icon: <DeleteOutlined style={{ color: '#f00' }} />,
            });
        });
    }

    const TinnitisSelect = (event) => {
        setTinnitis(event.target.value);
    }



    return (
        <div>
            <React.Fragment>
            {loading ? <Skeleton active /> : <>
                <Radio.Group value={isTinnitis} onChange={TinnitisSelect} buttonStyle="solid" size="large" style={{marginTop: '20px'}}>
                    <Radio.Button value={'Yes'}>Yes</Radio.Button>
                    
                    <Popover
                        content={<a onClick={deleteTinnitis}>Delete</a>}
                        title="Are you sure you want to delete All Record of Tinnitis?"
                        trigger="click"
                        visible={popup}
                        onVisibleChange={() => {
                            if(getGlobal().ChiefComplaints_location.LeftEar && getGlobal().ChiefComplaints_location.LeftEar.Tinnitis){setPopup(!popup)}
                        }}
                    >
                        {/* <DeleteOutlined /> */}
                        <Radio.Button value={'No'}>No</Radio.Button>

                        
                    
                    </Popover>

                </Radio.Group>
               
               {isTinnitis === 'Yes' && <Button className="SaveFormButton" loading={loadingBtn} style={{float: 'right'}} onClick={saveTheForm} type="primary">Save</Button>}
  

                {isTinnitis === 'Yes' ? 

                    <ul className='showFieldsTable'>
                        <li><span>Duration</span>
                            <Radio.Group name="Duration" value={state && state['Duration']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'1 day'}>1 Day</Radio.Button>
                                <Radio.Button value={'< week'}>&lt; Week</Radio.Button>
                                <Radio.Button value={'< 2 week'}>&lt; 2 Weeks</Radio.Button>
                                <Radio.Button value={'< month'}>&lt; Month</Radio.Button>
                                <Radio.Button value={'< 3 months'}>&lt; 3 Months</Radio.Button>
                                <Radio.Button value={'< 6 months'}>&lt; 6 Months</Radio.Button>
                                <Radio.Button value={'< year'}>&lt; Year</Radio.Button>
                                <Radio.Button value={'> year'}>&gt; Year</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Onset</span>
                            <Radio.Group name="Onset" value={state && state['Onset']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Sudden'}>Sudden</Radio.Button>
                                <Radio.Button value={'Gradual'}>Gradual</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Progression</span>
                            <Radio.Group name="Progression" value={state && state['Progression']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Not Progressive'}>Not Progressive</Radio.Button>
                                <Radio.Button value={'Slow Progressive'}>Slow Progressive</Radio.Button>
                                <Radio.Button value={'Fast Progressive'}>Fast Progressive</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Fluctuating</span>
                            <Radio.Group name="Fluctuating" value={state && state['Fluctuating']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'No'}>No</Radio.Button>
                                <Radio.Button value={'Yes'}>Yes</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Severity</span>
                            <Radio.Group name="Severity" value={state && state['Severity']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Mild'}>Mild</Radio.Button>
                                <Radio.Button value={'Moderate'}>Moderate</Radio.Button>
                                <Radio.Button value={'Severe'}>Severe</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Noise Intolerance</span>
                            <Radio.Group name="Noise Intolerance" value={state && state['Noise Intolerance']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'No'}>No</Radio.Button>
                                <Radio.Button value={'Yes'}>Yes</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Aggravating Factors</span>
                            {/* <Radio.Group name="Aggravating Factors" value={state && state['Aggravating Factors']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Not Known'}>Not Known</Radio.Button>
                                <Radio.Button value={'Cold / Flue / URTIs'}>Cold / Flue / URTIs</Radio.Button>
                                <Radio.Button value={'Alergy'}>Alergy</Radio.Button>
                                <Radio.Button value={'Trauma / Ear or Skull Surgery'}>Trauma / Ear or Skull Surgery</Radio.Button>
                                <Radio.Button value={'Enter of Water into ear canal'}>Enter of Water into ear canal</Radio.Button>
                                <Radio.Button value={'Others'}>Others</Radio.Button>
                            </Radio.Group> */}
                            <Checkbox.Group name="Aggravating Factors" value={state && state['Aggravating Factors']} buttonStyle="solid" onChange={(val) => getCheckBoxONChange(val, 'Aggravating Factors')} size="large">
                                <Checkbox value="Not Known" style={{ lineHeight: '32px' }}>
                                Not Known
                                </Checkbox>
                                <Checkbox value="Cold / Flue / URTIs" style={{ lineHeight: '32px' }}>
                                Cold / Flue / URTIs
                                </Checkbox>
                                <Checkbox value="Alergy" style={{ lineHeight: '32px' }}>
                                Alergy
                                </Checkbox>
                                <Checkbox value="Trauma / Ear or Skull Surgery" style={{ lineHeight: '32px' }}>
                                Trauma / Ear or Skull Surgery
                                </Checkbox>
                                <Checkbox value="Enter of Water into ear canal" style={{ lineHeight: '32px' }}>
                                Enter of Water into ear canal
                                </Checkbox>
                                <Checkbox value="other" style={{ lineHeight: '32px' }}>
                                other
                                </Checkbox>
                            </Checkbox.Group>
                       

                        </li>
                        <li><span>Relieving Factors</span>
                            {/* <Radio.Group name="Relieving Factors" value={state && state['Relieving Factors']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Not Known'}>Not Known</Radio.Button>
                                <Radio.Button value={'Self Remitting'}>Self Remitting</Radio.Button>
                                <Radio.Button value={'Ear Drops'}>Ear Drops</Radio.Button>
                                <Radio.Button value={'Medication'}>Medication</Radio.Button>
                                <Radio.Button value={'Others'}>Others</Radio.Button>
                            </Radio.Group> */}
                            <Checkbox.Group name="Relieving Factors" value={state && state['Relieving Factors']} buttonStyle="solid" onChange={(val) => getCheckBoxONChange(val, 'Relieving Factors')} size="large">
                                <Checkbox value="Not Known" style={{ lineHeight: '32px' }}>
                                Not Known
                                </Checkbox>
                                <Checkbox value="Self Remitting" style={{ lineHeight: '32px' }}>
                                Self Remitting
                                </Checkbox>
                                <Checkbox value="Ear Drops" style={{ lineHeight: '32px' }}>
                                Ear Drops
                                </Checkbox>
                                <Checkbox value="Medication" style={{ lineHeight: '32px' }}>
                                Medication
                                </Checkbox>
                                <Checkbox value="other" style={{ lineHeight: '32px' }}>
                                other
                                </Checkbox>
                            </Checkbox.Group>
                        </li>
                        <li><span>Causative Factors</span>
                            {/* <Radio.Group name="Causative Factors" value={state && state['Causative Factors']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Not Known'}>Not Known</Radio.Button>
                                <Radio.Button value={'Cold / Flue / URTIs'}>Cold / Flue / URTIs</Radio.Button>
                                <Radio.Button value={'Trauma / Ear or Skull Surgery'}>Trauma / Ear or Skull Surgery</Radio.Button>
                                <Radio.Button value={'Enter of Water into ear canal'}>Enter of Water into ear canal</Radio.Button>
                                <Radio.Button value={'Others'}>Others</Radio.Button>
                            </Radio.Group> */}
                            <Checkbox.Group name="Causative Factors" value={state && state['Causative Factors']} buttonStyle="solid" onChange={(val) => getCheckBoxONChange(val, 'Causative Factors')} size="large">
                            <Checkbox value="Not Known" style={{ lineHeight: '32px' }}>
                                Not Known
                                </Checkbox>
                                <Checkbox value="Cold / Flue / URTIs" style={{ lineHeight: '32px' }}>
                                Cold / Flue / URTIs
                                </Checkbox>
                                <Checkbox value="Trauma / Ear or Skull Surgery" style={{ lineHeight: '32px' }}>
                                Trauma / Ear or Skull Surgery
                                </Checkbox>
                                <Checkbox value="Enter of Water into ear canal" style={{ lineHeight: '32px' }}>
                                Enter of Water into ear canal
                                </Checkbox>
                                <Checkbox value="other" style={{ lineHeight: '32px' }}>
                                other
                                </Checkbox>
                            </Checkbox.Group>
                        </li>
                        <li><span>Assocaited Symptoms</span>
                            {/* <Radio.Group name="Assocaited Factors" value={state && state['Assocaited Factors']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Discharge'}>Discharge</Radio.Button>
                                <Radio.Button value={'Hearing Loss'}>Hearing Loss</Radio.Button>
                                <Radio.Button value={'Tinnitis'}>Tinnitis</Radio.Button>
                                <Radio.Button value={'Vertigo'}>Vertigo</Radio.Button>
                                <Radio.Button value={'Others'}>Others</Radio.Button>
                            </Radio.Group> */}
                            <Checkbox.Group name="Assocaited Symptoms" value={state && state['Assocaited Symptoms']} buttonStyle="solid" onChange={(val) => getCheckBoxONChange(val, 'Assocaited Symptoms')} size="large">
                                <Checkbox value="Not Known" style={{ lineHeight: '32px' }}>
                                Not Known
                                </Checkbox>
                                <Checkbox value="Pain" style={{ lineHeight: '32px' }}>
                                Pain
                                </Checkbox>
                                <Checkbox value="Hearing Loss" style={{ lineHeight: '32px' }}>
                                Hearing Loss
                                </Checkbox>
                                <Checkbox value="Tinnitis" style={{ lineHeight: '32px' }}>
                                Tinnitis
                                </Checkbox>
                                <Checkbox value="Vertigo" style={{ lineHeight: '32px' }}>
                                Vertigo
                                </Checkbox>
                                <Checkbox value="other" style={{ lineHeight: '32px' }}>
                                other
                                </Checkbox>
                            </Checkbox.Group>
                       
                        </li>
                        <li><span>Treatment Taken</span>
                            {/* <Radio.Group name="Treatment Taken" value={state && state['Treatment Taken']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Medication'}>Medication</Radio.Button>
                                <Radio.Button value={'Surgery'}>Surgery</Radio.Button>
                                <Radio.Button value={'Drops'}>Drops</Radio.Button>
                                <Radio.Button value={'Others'}>Others</Radio.Button>
                            </Radio.Group> */}
                            <Checkbox.Group name="Treatment Taken" value={state && state['Treatment Taken']} buttonStyle="solid" onChange={(val) => getCheckBoxONChange(val, 'Treatment Taken')} size="large">
                                <Checkbox value="Not Known" style={{ lineHeight: '32px' }}>
                                Not Known
                                </Checkbox>
                                <Checkbox value="Medication" style={{ lineHeight: '32px' }}>
                                Medication
                                </Checkbox>
                                <Checkbox value="Surgery" style={{ lineHeight: '32px' }}>
                                Surgery
                                </Checkbox>
                                <Checkbox value="Drops" style={{ lineHeight: '32px' }}>
                                Drops
                                </Checkbox>
                                <Checkbox value="other" style={{ lineHeight: '32px' }}>
                                other
                                </Checkbox>
                            </Checkbox.Group>
                        </li>
                        <li><span>Using Hearing Aids</span>
                            <Radio.Group name="Using Hearing Aids" value={state && state['Using Hearing Aids']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'No'}>No</Radio.Button>
                                <Radio.Button value={'Yes'}>Yes</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Family History of hearing Loss</span>
                            <Radio.Group name="Family History of hearing Loss" value={state && state['Family History of hearing Loss']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'No'}>No</Radio.Button>
                                <Radio.Button value={'Yes'}>Yes</Radio.Button>
                            </Radio.Group>
                        </li>
                       <Button className="SaveFormButton" loading={loadingBtn} onClick={saveTheForm} type="primary">Save</Button>
                    </ul>

                    
                : ''}
                </>}
            </React.Fragment>
 
        </div>
    );
}

export default Tinnitis;
